var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22264 17.2071C3.13511 17.706 3.62738 18.0965 4.06212 17.8731L9 15.3351L13.9379 17.8731C14.3726 18.0965 14.8649 17.706 14.7774 17.2071L13.8439 11.8864L17.8065 8.1102C18.1769 7.75729 17.9852 7.11204 17.4891 7.04156L11.9783 6.2587L9.52114 1.39134C9.2998 0.952886 8.70021 0.952886 8.47886 1.39134L6.02173 6.2587L0.510943 7.04156C0.0148305 7.11204 -0.17687 7.75729 0.193459 8.1102L4.15608 11.8864L3.22264 17.2071ZM8.74032 14.0929L4.59385 16.2241L5.37488 11.7722C5.4117 11.5623 5.34247 11.3474 5.19179 11.2038L1.9216 8.08745L6.48044 7.43983C6.6689 7.41305 6.83345 7.29269 6.92236 7.11658L9 3.00096L11.0776 7.11658C11.1665 7.29269 11.3311 7.41305 11.5196 7.43983L16.0784 8.08745L12.8082 11.2038C12.6575 11.3474 12.5883 11.5623 12.6251 11.7722L13.4062 16.2241L9.25968 14.0929C9.09589 14.0088 8.90411 14.0088 8.74032 14.0929Z",
    fill: "#16B054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c1ffeb9952d8de3ce02b87c1cb106e52.svg";
export { ForwardRef as ReactComponent };